import Direction2D from '../Direction2D';
import { equalWithinTolerance } from './equalsWithinTolerance';

const angleTolerance = 0.1;

export function angleEquals(angle1: number, angle2: number) {
  return equalWithinTolerance(angle1, angle2, angleTolerance);
}

export function angleGreaterThanOrEqual(angle1: number, angle2: number) {
  return angle1 > angle2 || angleEquals(angle1, angle2);
}

export function angleLessThanOrEqual(angle1: number, angle2: number) {
  return angle1 < angle2 || angleEquals(angle1, angle2);
}

export function angleLessThan(angle1: number, angle2: number) {
  return angle1 < angle2 && !angleEquals(angle1, angle2);
}

export function supplementalAngleDegrees(angleInDegrees: number) {
  return straightAngle - (angleInDegrees % perigon);
}

export function angleComparator(angle1: number, angle2: number) {
  return angleEquals(angle1, angle2) ? 0 : angle1 - angle2;
}

export const rightAngle = 90;
export const straightAngle = 180;
export const perigon = 360;
export const fullCircle = 360;

export const convertDegreesToRadians = (degrees: number) => (degrees / 180) * Math.PI;
export const convertRadiansToDegrees = (radians: number) => (radians / Math.PI) * 180;

export function vectorToDegrees(value: { x: number; y: number }) {
  const angle = convertRadiansToDegrees(Math.atan2(value.y, value.x));
  return angle < 0 ? angle + 360 : angle;
}

export function degreesToVector(value: number): { x: number; y: number } {
  return Direction2D.right.rotate(value).toObject();
}

export const slopeToDegrees = (slope: number) => convertRadiansToDegrees(Math.atan(slope / 12));

export function degreesToSlope(value: number): number {
  return Math.tan(convertDegreesToRadians(value)) * 12;
}

export const zeroDotProductTolerance = Math.sin(convertDegreesToRadians(angleTolerance));

export const isDotProductZero = (dotProduct: number) => equalWithinTolerance(dotProduct, 0, zeroDotProductTolerance);
